import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EngineDataQueryService, UpdateData } from '@tj/tj-dmp-lib-api';
import { ConfirmationService, MessageService, SortEvent } from 'primeng/api';

@Component({
    selector: 'dmp-dyn-raw-detail-history',
    templateUrl: './dyn-raw-detail-history.component.html',
    styleUrls: ['./dyn-raw-detail-history.component.scss'],
    standalone: false
})
export class DynRawDetailHistoryComponent implements OnInit {
  @Input() tenant: string;
  @Input() tableIdsForHistory: { [key: string]: number };
  @Input() idDataview: string;
  @Input() partner: string

  rowsData: Array<any> = [];
  columns: Array<{ field: string, header: string }> = [];
  loading: boolean = true;
  sortField: string = null;
  sortOrder: number = 1; 

  columnMapping = [
    { field: 'tools_log_update.datetime', header: 'view.details.history.date' },
    { field: 'tools_log_update.table', header: 'view.details.history.table' },
    { field: 'tools_log_update.column', header: 'view.details.history.column' },
    { field: 'tools_log_update.oldValue', header: 'view.details.history.oldValue' },
    { field: 'tools_log_update.newValue', header: 'view.details.history.newValue' },
    { field: 'tools_log_update.userDatabase', header: 'view.details.history.modifiedBy' },
    { field: 'tools_log_update.version', header: 'view.details.history.version' }
  ]

  constructor(
    private queryService: EngineDataQueryService,
    private messageService: MessageService,
    private translate: TranslateService,
    private confirmationService: ConfirmationService
  ) { }

  ngOnInit(): void {
    this.columns = this.columnMapping
    this.loadData();
  }

  customSort(event: SortEvent) {
    const multiSortMeta = event.multiSortMeta;
    event.data.sort((data1, data2) => {
      let value1, value2, result = 0;

      for (let i = 0; i < multiSortMeta.length; i++) {
        const sortField = multiSortMeta[i].field;
        const sortOrder = multiSortMeta[i].order;

        value1 = data1[sortField];
        value2 = data2[sortField];

        // Traitement spécial pour les dates
        if (sortField === 'tools_log_update.datetime') {
          value1 = value1 ? new Date(value1).getTime() : 0;
          value2 = value2 ? new Date(value2).getTime() : 0;
        }

        // Traitement spécial pour les nombres
        else if (typeof value1 === 'string' && !isNaN(Number(value1.replace(',', '.')))) {
          value1 = Number(value1.replace(',', '.'));
          value2 = Number(value2.replace(',', '.'));
        }


        if (value1 == null && value2 != null) {
          result = -1;
        } else if (value1 != null && value2 == null) {
          result = 1;
        } else if (value1 == null && value2 == null) {
          result = 0;
        } else if (typeof value1 === 'string' && typeof value2 === 'string') {
          result = value1.localeCompare(value2);
        } else {
          result = (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0;
        }

        result = result * sortOrder

        if (result != 0) {
          break;
        }
      }

      return result;
    });

    return event.data;
  }

  restoreFieldPreviousValue(i: number) {
    const column = this.rowsData[i]['tools_log_update.column']
    this.confirmationService.confirm({
      message: this.translate.instant('view.details.history.confirmation.restoreValue', {
        column: column
      }),
      header: this.translate.instant('view.details.history.confirmation.header'),
      acceptLabel: this.translate.instant('view.details.history.confirmation.accept'),
      rejectLabel: this.translate.instant('view.details.history.confirmation.reject'),
      accept: () => {
        const table = this.rowsData[i]['tools_log_update.table']
        const updateData = {
          idDataview: this.idDataview,
          tenant: this.tenant,
          partner: this.partner,
          updateField: {
            [`${table}.${this.rowsData[i]['tools_log_update.column']}`]: this.rowsData[i]['tools_log_update.oldValue']
          },
          idForTable: {
            [`${table}.id`]: parseInt(this.rowsData[i]['tools_log_update.idRow'], 10)
          }
        } as UpdateData
        this.queryService.updateData(updateData, this.tenant).subscribe({
          next: (res) => {
            if (res) {
              this.messageService.add({
                severity: 'success',
                summary: this.translate.instant('view.details.history.success.success'),
                detail: this.translate.instant('view.details.history.success.modificationsCancelled')
              });
              this.loadData();
            }
          }, error: () => {
            this.messageService.add({
              severity: 'error',
              summary: this.translate.instant('view.details.history.error.error'),
              detail: this.translate.instant('view.details.history.error.error.unableToCancelledModification')
            })
          }
        })
      }
    });
  }

  private loadData(): void {
    this.loading = true;
    this.rowsData = [];

    this.queryService.getTableDataModificationHistory(this.tableIdsForHistory, this.tenant).subscribe({
      next: (res) => {
        const rows = res.content;
        if (rows && rows.length > 0) {
          for (const row of rows) {
            this.rowsData.push(row.rows);
          }
        }
        this.loading = false;
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('ERROR'),
          detail: this.translate.instant('UNABLE_TO_LOAD_HISTORY')
        });
        this.loading = false;
      }
    });
  }
}
